const ViewModes = {
    CREATE: 'CREATE',
    DEFAULT: 'DEFAULT',
    EDIT: 'EDIT',
    SELECT: 'SELECT'
};

export default ViewModes;
